export const INVENTORY_COUNT_EMPTY_INVENTORY_TABLE_VALUE = '-';
export const INVENTORY_COUNT_INVENTORY_MIN_VALUE = 0;
